const checkoutForm = document.querySelector('[data-checkout]');

checkoutForm && (() => {
  let indexGroup = 0;
  const groups = checkoutForm.querySelectorAll('div[data-group]');
  const buttons = checkoutForm.querySelectorAll('button[data-group]');
  const nextButton = checkoutForm.querySelector('[data-next]');
  const fields = checkoutForm.querySelectorAll('[name]');

// do not submit checkout on enter hit
  checkoutForm.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });

// show only the payment method that goes with the chosen shipping option:
// Delivery → Pay via invoice, anything else → the card methods. The server
// renders both, so switching doesn't change the payment section (WooCommerce
// would replace it and Stripe would lose its currency selector), and checks
// the pairing again on submit (app/includes/fulfilment.php).
  const syncPaymentToShipping = () => {
    const methods = [...checkoutForm.querySelectorAll('.wc_payment_methods > li.wc_payment_method')];
    if (methods.length < 2) {
      return;
    }

    const shipping = checkoutForm.querySelector('input.shipping_method:checked, input.shipping_method[type="hidden"]');
    const isDelivery = !!shipping && shipping.value.split(':')[0] === 'rof_delivery_quote';

    methods.forEach((method) => {
      const isInvoice = method.classList.contains('payment_method_rof_invoice');
      method.style.display = isInvoice === isDelivery ? '' : 'none';
    });

    const checked = checkoutForm.querySelector('input[name="payment_method"]:checked');
    if (!checked || checked.closest('li').style.display === 'none') {
      const next = methods
        .find((method) => method.style.display !== 'none')
        ?.querySelector('input[name="payment_method"]');

      // WooCommerce opens the method's box on click, not change.
      next?.click();
    }
  };

  checkoutForm.addEventListener('change', (e) => {
    if (e.target.matches('input.shipping_method')) {
      syncPaymentToShipping();
    }
  });
  window.jQuery?.(document.body).on('updated_checkout', syncPaymentToShipping);

// remove .is-error class on input change
  fields.forEach((field) => {
    field.addEventListener('input', (e) => {
      field.classList.remove('is-error');
    });
  });

  const switchGroup = (d) => {
    indexGroup += d;
    groups.forEach(
      (group, i) => group.classList.toggle('is-active', i === indexGroup));
    buttons.forEach(
      (group, i) => group.classList.toggle('is-active', i === indexGroup));
  };

// can go back only if there is a previous group
  buttons.forEach((button, i) => {
    button.addEventListener('click', (e) => {
      if (i < indexGroup) {
        switchGroup(-1);
      }
    });
  });

  nextButton.addEventListener('click', (e) => {
    let groupFields = groups[indexGroup].querySelectorAll(
      '.validate-required [name]');

    const shipToDifferentAddress = groups[indexGroup].querySelector(
      '[name="ship_to_different_address"]');
    // if shipping to different address is not checked, remove all shipping fields
    if (!shipToDifferentAddress || !shipToDifferentAddress.checked) {
      groupFields = [...groupFields].filter((field) => {
        return field.name.indexOf('shipping_') !== 0;
      });
    }

    // check if all required fields are filled
    const allFilled = [...groupFields].every((field) => {
      return field.value !== '';
    });

    if (!allFilled) {
      let isFocused = false;
      groupFields.forEach((field) => {
        if (field.value === '') {
          field.classList.add('is-error');

          if (!isFocused) {
            field.focus();
            isFocused = true;
          }
        }
      });

    } else {
      switchGroup(1);
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  });
})();

